import store from "../../../store";
import { getProfile } from "../../../providers/users";
import { findUserAssociations, getEcomAvailabilityByAfm, getMerchantOrderStatus } from "../../../providers/merchants";
import { getAssociations } from "../../../providers/authorizations";
import { redirectToCardlink, setUserLoggedInStatus, toggleHelpBubble } from "../../../actions/userActions";

// Shared logic for handling a valid user profile after login/SFA
export function checkUserNotConfirmed(profile, setState, invalidateAllErrors) {
    // when the user is not confirmed the whole payload returned is null
    if (profile === null) {
        invalidateAllErrors();
        setState({
            nonConfirmedAccount: true
        });
        return 1;
    }
    return 0;
}

export function checkUserDisabledFlag(profile, setState, invalidateAllErrors) {
    if (profile.disabled === true) {
        invalidateAllErrors();
        setState({
            disabledAccount: true
        });
        return 1;
    }
    return 0;
}

export function checkRoleIsMerchant(profile, setState, invalidateAllErrors) {
    if (profile.role !== 'MERCHANT') {
        invalidateAllErrors();
        setState({
            roleNotMerchant: true
        });
        return 1;
    }
    return 0;
}

export function checkUserIsValid(profile, helpers) {
    const { setState, invalidateAllErrors } = helpers;
    if (checkUserNotConfirmed(profile, setState, invalidateAllErrors) !== 1)
        if (checkUserDisabledFlag(profile, setState, invalidateAllErrors) !== 1)
            if (checkRoleIsMerchant(profile, setState, invalidateAllErrors) !== 1)
                return 0;

    return 1;
}

export function checkIfTermsAreNotAccepted(errorResponse) {
    return errorResponse === 'TERMS_AND_CONDITIONS_LATEST_VERSION_NOT_ACCEPTED'
}

export function validUserActions(profileResponse, showTermsAndConditions, helpers) {
    const { setState, invalidateAllErrors, props } = helpers;
    const profile = profileResponse.value.data.payload;
    const defaultPageOverview = profile.defaultPageOverview;

    if (checkUserIsValid(profile, { setState, invalidateAllErrors }) === 0) {
        invalidateAllErrors();
        // User profile is valid - set logged in status BEFORE fetching additional data
        store.dispatch(setUserLoggedInStatus(true));

        store.dispatch(getMerchantOrderStatus(undefined, undefined)).then(() => {
            if (showTermsAndConditions && props.showTermsAndConditions) {
                props.showTermsAndConditions(false);
            }
            getMidsEtc(defaultPageOverview, helpers);
            store.dispatch(getEcomAvailabilityByAfm());
            store.dispatch(toggleHelpBubble(true));
        });
    } else {
        store.dispatch(setUserLoggedInStatus(false));
        setState({
            loginButtonLoaderEnabled: false
        });
    }
}

export function getMidsEtc(hideIntroScreen, helpers) {
    const { props } = helpers;
    store.dispatch(getAssociations(-1)).then(() => {
        store.dispatch(setUserLoggedInStatus(true))
        if (hideIntroScreen) {
            if (props.showIntroScreen) {
                props.showIntroScreen(false);
            }
            if (props.history) {
                props.history.push({
                    pathname: '/overview',
                    search: props.location && props.location.state ?
                        (props.location.state.from ? props.location.state.from.search : null) : null
                });
            }
        } else {
            if (props.showIntroScreen) {
                props.showIntroScreen(true);
            }
            if (props.history) {
                props.history.push({
                    pathname: '/introScreen',
                });
            }
        }
    });
}

// Shared function to get profile + run actions after successful login/SFA
export function getProfileActionsShared(showTermsAndConditions, helpers) {
    store.dispatch(getProfile()).then(
        (response) => {
            const profileSource = response.value && response.value.data && response.value.data.payload && response.value.data.payload.source;
            if (profileSource === 'cardlink-one') {
                store.dispatch(findUserAssociations()).then((res) => {
                    if (!res.value.data.payload || res.value.data.payload.length === 0) {
                        store.dispatch(redirectToCardlink(true));
                    } else {
                        validUserActions(response, showTermsAndConditions, helpers);
                    }
                });
            } else {
                validUserActions(response, showTermsAndConditions, helpers);
            }
        },
        () => {
            // swallow error, UI should stay on login/SFA screen
        }
    );
}

